<div id="navigationContainer">
  <header class="menu-principal menu-{{menuData.classKey}}">
    <div class="content-header">
      <a class="logo" routerLink="/">
        <img src="/assets/arc.svg" alt="log fondation arc">
      </a>

      @if (authService.userConnected) {
        <nav role="navigation">
          <ul id="menu-deroulant">
            @for (group of menuData.menu; track group) {
              <li>
                @if (group.label === 'menu.mesMandats') {
                  <a (click)="mesMandatsDetails()"
                    class="link-menu">
                    {{group.label | translate}} ({{mesMandats}})
                  </a>
                } @else {
                  @if (group.children.length) {
                    <a href="javascript:void(null);"
                      [class.active]="testLinksActive(group.children)" class="link-menu">
                      {{ group.label | translate }}
                      <mat-icon class="mat-icon">arrow_drop_down</mat-icon>
                      <span class="active-marker"></span>
                      @if (group.children.length) {
                        <ul class="sub-menu">
                          @for (link of group.children; track link) {
                            <li>
                              @if (!link.children) {
                                <a [routerLink]="link.url" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}"> {{link.label | translate}}</a>
                              } @else {
                                <div (mouseenter)="showChildren(link)" (mouseleave)="showChildren(null)">
                                  <a [routerLink]="[]">
                                    <mat-icon>arrow_right</mat-icon>
                                  {{link.label | translate}}</a>
                                  @if (link.label === subChild) {
                                    <ul class="sub-menu"
                                      class="sub-menu sub-menu-child">
                                      @for (child of link.children; track child) {
                                        <li>
                                          <a [routerLink]="child.url" routerLinkActive="active"
                                          [routerLinkActiveOptions]="{exact: true}"> {{child.label | translate}}</a>
                                        </li>
                                      }
                                    </ul>
                                  }
                                </div>
                              }
                            </li>
                          }
                        </ul>
                      }
                    </a>
                  }
                  @if (!group.children.length) {
                    <a [routerLink]="group['url']" routerLinkActive="active"
                      [routerLinkActiveOptions]="{exact: true}" class="link-menu">
                      {{ group.label | translate }}
                      <span class="active-marker"></span>
                    </a>
                  }
                }
              </li>
            }
          </ul>
        </nav>
      }

      <div class="user-actions">
        <div class="contact" (click)="contact()">
          Contact
        </div>

        <div class="faq"
          [routerLink]="'/accueil/faq/consultation'"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          FAQ
        </div>

        <div class="language" [matMenuTriggerFor]="menu">
          <mat-icon>language</mat-icon>
        </div>

        <div class="profil" [matMenuTriggerFor]="menuProfil">
          <span class="username">
            {{authService.displayName}}
          </span>
          <span class="role">{{displayRole}}</span>
        </div>
      </div>
    </div>
  </header>
  <div style="height: 100px; pointer-events: none;"></div>

  <mat-menu #menuProfil="matMenu" class="menu-light min-220" [overlapTrigger]="false">
    <button mat-menu-item
    routerLink="/profil/view">{{ 'front.profilActivate.accederMoncompte' | translate }}</button>
    <button mat-menu-item class="logout" (click)="logout()">{{ 'general.deconnexion' | translate }}</button>
  </mat-menu>

  <mat-menu #menu="matMenu">
    @for (item of LANGUAGES; track item) {
      <button mat-menu-item (click)="setLangue(item.code)">
        {{'general.'+item.code | translate}} @if (getCurrentLanguage() === item.code) {
        <span class="check-language"><mat-icon>check</mat-icon></span>
      }
    </button>
  }
</mat-menu>

</div>
